import { isObject, isOriginAllowed, sendMessage } from './utils'
import tagularModule from '../store/helpers/tagular'

function receiveMessage(event) {
  const { origin, data } = event

  if (window.env !== 'local' && !isOriginAllowed(origin)) return
  if (!isObject(data) || !data.type) return

  switch (data.type) {
    case 'reco-widget.CLOSE': {
      window.disableRecoWidget()
      break
    }
    case 'reco-widget.RESULTS': {
      window.disableRecoWidget()
      window.location.href = data.value.redirectPath
      break
    }
    case 'reco-widget.READY': {
      const utmParam = 'utm_content=bank_reco_banner_ed_8_24'
      sendMessage({
        type: 'reco-widget.BOOTSTRAP',
        value: { utmParam }
      })
      break
    }
  }
}

/**
 * Fires a tracking event when a user clicks on the "Get Started" button on the Bank Reco Widget.
 */
function trackBankRecoWidgetClick() {
  tagularModule.elementClicked({
    actionOutcome: 'Initiate BankMatch flow',
    elementType: 'Button',
    location: 'BANK_RECO',
    position: 'bottom of the page',
    text: 'Get_started'
  })
}

/**
 * Fires a tracking event for when the Bank Reco Widget enters the users viewport/screen.
 * @param {Element} element The element containing the widget
 */
function trackBankRecoWidgetViewed(element) {
  if (!element) return

  const callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        tagularModule.elementViewed({
          elementType: 'Button',
          htmlId: 'deposits-reco-widget',
          location: 'BANK_RECO',
          position: 'bottom of the page',
          text: 'Which_bank_should_I_choose'
        })

        // Disconnect intersection observer so it only fires once
        observer.disconnect()
      }
    })
  }

  const observer = new IntersectionObserver(callback, {
    rootMargin: '0px',
    threshold: 1.0
  })

  observer.observe(element)
}

const recoIframe = document.getElementById('deposits-reco-widget')
const recoWidget = document.querySelector('.reco-widget-cta')
const recoCta = document.querySelector('.reco-widget-cta__wrapper')
const recoCtaButton = document.querySelector('.reco-widget-cta__button-wrapper')

recoCtaButton.addEventListener('click', showWidget)

function showWidget() {
  recoCta.classList.add('--hidden')
  recoIframe.classList.remove('--hidden')
  trackBankRecoWidgetClick()
}

function enableRecoWidget() {
  recoWidget.classList.remove('--hidden')
}

function disableRecoWidget() {
  recoWidget.classList.add('--hidden')
}

window.enableRecoWidget = enableRecoWidget
window.disableRecoWidget = disableRecoWidget

window.addEventListener('message', receiveMessage, false)
trackBankRecoWidgetViewed(recoWidget)
